export enum FooterTheme {
  Dark = 'dark',
  Light = 'light',
}
